"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var commentLoadUtil_1 = require("../utils/commentLoadUtil");
var MobileNotificationsComponent = (function (_super) {
    __extends(MobileNotificationsComponent, _super);
    function MobileNotificationsComponent(params, element, templateNodes) {
        _super.call(this, params, element, templateNodes);
        this.userNotificationCount = ko.observable(0);
        this.unreadCommentCount = ko.observable(0);
        this.unreadPMCount = ko.observable(0);
        this.reload();
    }
    MobileNotificationsComponent.prototype.reload = function () {
        var _this = this;
        var commentsContainer = $("#commentsAsync");
        if (commentsContainer.length == 0) {
            this.notificationCheck();
        }
        else {
            var subscription = commentLoadUtil_1.default.loaded.subscribe(function (value) {
                if (value) {
                    _this.notificationCheck();
                    subscription.dispose();
                }
            });
        }
    };
    MobileNotificationsComponent.prototype.notificationCheck = function () {
        var _this = this;
        ajaxUtils_1.AjaxUtils.get("notification/check", {})
            .done(function (result) {
            if (!result.isSuccessful) {
                return;
            }
            _this.userNotificationCount(result.data.userNotificationCount);
            _this.unreadCommentCount(result.data.unreadCommentCount);
            _this.unreadPMCount(result.data.unreadPMCount);
        });
    };
    return MobileNotificationsComponent;
}(baseComponent_1.default));
ko.components.register("mobile-notifications", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileNotificationsComponent;
//# sourceMappingURL=mobileNotifications.js.map